import '@pleo-io/react-sparklines/build/index.css'
import 'react-select/dist/react-select.css'
import '../../node_modules/react-virtualized/styles.css' // relative import is needed due to https://github.com/bvaughn/react-virtualized/issues/1212
import './overrides/intercom.css'
import '~/generic-ui/select-legacy/react-select-override.css'
import './global.css'
import './reset.css'
import './fonts.css'
import '@pleo-io/telescope-tokens/dist/spacing.css'
import '@pleo-io/telescope-tokens/dist/color.css'
import '@pleo-io/telescope-tokens/dist/color-scheme-light.css'
import '@pleo-io/telescope-tokens/dist/color-scheme-dark.css'
import '@pleo-io/telescope-tokens/dist/rgba.css'
import '@pleo-io/telescope-tokens/dist/opacity.css'
import '@pleo-io/telescope-tokens/dist/radius.css'
import '@pleo-io/telescope-tokens/dist/font-size.css'
import '@pleo-io/telescope-tokens/dist/font-weight.css'
import '@pleo-io/telescope-tokens/dist/line-height.css'
import '@pleo-io/telescope-tokens/dist/duration.css'
import '@pleo-io/telescope-tokens/dist/transition.css'
import '@pleo-io/telescope-tokens/dist/z-index.css'
import '@pleo-io/telescope-tokens/dist/border.css'
import '@reach/skip-nav/styles.css'

import config from 'config'

if (['product-dev', 'feature'].includes(config.environment)) {
    import('./border-box.css')
}
